import styled from 'styled-components/macro';
import Button from 'components/atoms/Button';

export const StyledMidSelection = styled.div`
  h3 {
    margin-bottom: 8px;
    color: #007bff;
    font-size: 18px;
  }

  p {
    margin-bottom: 20px;
    color: #6c757d;
  }

  .mids-container {
    .mid-section {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      h4 {
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 600;
        color: #495057;
      }

      .previous-mids {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }
`;

export const StyledMidButton = styled(Button)`
  width: 100%;
  height: auto;
  padding: 0 !important;
  margin-bottom: 8px;
  min-height: 50px;

  .mid-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    width: 100%;

    .mid-value {
      font-weight: 600;
      font-size: 16px;
    }

    .mid-label {
      font-size: 10px;
      font-weight: 700;
      padding: 2px 6px;
      border-radius: 3px;
      text-transform: uppercase;
    }
  }
`;

export const StyledCurrentMidButton = styled(StyledMidButton)`
  border: 2px solid #28a745;
  background: #d4edda;
  color: #155724;

  &:hover {
    background: #28a745;
    border-color: #1e7e34;
    color: white;
  }

  .mid-info {
    .mid-value {
      color: #155724;
    }

    .mid-label {
      background: #28a745;
      color: white;
    }
  }

  &:hover .mid-info .mid-value {
    color: white;
  }
`;

export const StyledPreviousMidButton = styled(StyledMidButton)`
  border: 1px solid #dee2e6;
  background: #f8f9fa;
  color: #495057;

  &:hover {
    background: #007bff;
    border-color: #0056b3;
    color: white;
  }

  .mid-info {
    .mid-value {
      color: #495057;
    }

    .mid-label {
      background: #6c757d;
      color: white;
    }
  }

  &:hover .mid-info .mid-value {
    color: white;
  }
`;

export const StyledNoMidsMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;

  i {
    font-size: 48px;
    color: #ffc107;
    margin-bottom: 16px;
  }

  h3 {
    margin-bottom: 8px;
    color: #495057;
  }

  p {
    margin: 0;
    color: #6c757d;
  }
`;
